import { KitText } from '@omni/kit/components';
import Colors from '@omni/kit/theming/Colors';
import * as React from 'react';
import { ReactElement } from 'react';
import { TextStyle } from 'react-native';

type LabelProps = {
  children: string;
  style?: TextStyle;
};
const Label = ({ children, style }: LabelProps): ReactElement => (
  <KitText fontSize={14} semiBold color={Colors.N600} style={style || {}}>
    {children}
  </KitText>
);

export default Label;
